export const TABS = {
  caredriver: 'caredriver',
  rideOverview: 'rideOverview',
  rideLog: 'ridelog',
  smartPooling: 'smartPooling',
  fareDetails: 'fareDetails',
};
